import React, { FC } from 'react';
import { Form, Typography, Input } from 'antd';

import { ContainerWithForm, FormContainer } from '../../../components/Container';
import FooterNavigator from '../../../components/FooterNavigator';
import { PHN_DOCUMENTS, PHN_REFERER_DETAILS } from '../../../constants/routes';
import { useAppDispatch } from '../../../hooks/redux-hooks';
import { removeEmptyStrFields } from '../../../utils/object-check';
import { updateGpData } from '../../../redux/slices/booking';
import { mobileRegxPattern, trimPhoneNumber } from '../../../utils/phone-number';
import { getPrivateGpDetailsConfig } from '../../../config/privateBooking';

const HncGpDetails: FC = () => {
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();

  // analytics.logPageViewEvent(GP_DETAILS, {
  //   site: SITE_NAME,
  //   page_path: pathname,
  // });
  const { showFaxAndEmial } = getPrivateGpDetailsConfig();
  const submit = async () => {
    try {
      await form.validateFields();
      const values = await form.validateFields();
      const cleanedValues = removeEmptyStrFields(values);
      dispatch(updateGpData(cleanedValues));
      return true;
    } catch (error) {
      // analytics.trackVpcFormError({
      //   form_id: bookingData.formId,
      //   error_type: 'form_validation_error',
      //   page_path: pathname,
      // });
      return false;
    }
  };

  return (
    <ContainerWithForm>
      <Typography.Title level={2} style={{ marginBottom: '20px', color: '#5f6369', fontSize: '36px' }}>
        General Practitioner Details
      </Typography.Title>

      <FormContainer
        form={form}
        layout="vertical"
      >
        <Form.Item
          name="firstName"
          label="GP Given Name"
        >
          <Input placeholder="Enter GP given name" />
        </Form.Item>

        <Form.Item
          name="lastName"
          label="GP Surname"
        >
          <Input placeholder="Enter GP surname" />
        </Form.Item>

        <Form.Item
          name="clinicName"
          label="GP Clinic Name"
        >
          <Input placeholder="Enter clinic name" />
        </Form.Item>

        <Form.Item
          name="clinicPhoneNumber"
          label="Clinic Phone Number"
          normalize={trimPhoneNumber}
          rules={[
            {
              pattern: mobileRegxPattern,
              message: 'Please input a valid phone number.',
            },
          ]}
        >
          <Input placeholder="Enter clinic phone number" />
        </Form.Item>

        {showFaxAndEmial && (
        <>
          <Form.Item
            name="clinicFaxNumber"
            label="Clinic Fax Number"
            rules={[
              { pattern: /^\d+$/, message: 'Please enter valid fax number' },
            ]}
          >
            <Input placeholder="Enter clinic fax number" />
          </Form.Item>

          <Form.Item
            name="clinicEmail"
            label="Clinic Email"
            rules={[
              { type: 'email', message: 'Please enter valid email address' },
            ]}
          >
            <Input placeholder="Enter clinic email" />
          </Form.Item>
        </>
        )}
      </FormContainer>
      <FooterNavigator
        error=""
        submit={submit}
        next={PHN_REFERER_DETAILS}
        back={PHN_DOCUMENTS}
        containerStyle={{ marginTop: '40px' }}
      />
    </ContainerWithForm>
  );
};

export default HncGpDetails;
